import { Tabs as TabsBootstrap, Tab as TabBootstrap, Badge } from 'react-bootstrap';
import '../../assets/css/common/tab.css';

const Tabs = (props) => {
    const { tabs, style, handleClick } = props;

    return (
        <TabsBootstrap className="ok-navtabs__nav tab_nav" style={style} onSelect={(e) => handleClick(e)}>
            {tabs?.map((tab, index) => {
                return (
                    <TabBootstrap
                        key={index}
                        eventKey={tab.event}
                        tabClassName="nav-link ok-navtabs__link"
                        title={
                            tab.title && (
                                <div style={{ position: 'relative' }}>
                                    {tab.title}
                                    {tab.count > 0 && (
                                        <Badge
                                            bg="light"
                                            className={`${tab.count < 10 ? 'count-single' : tab.count < 100 ? 'count-double' : 'count-over'} tab-count`}
                                        >
                                            {tab.count >= 100 ? '99+' : tab.count}
                                        </Badge>
                                    )}
                                </div>
                            )
                        }
                    >
                        {tab.content}
                    </TabBootstrap>
                );
            })}
        </TabsBootstrap>
    );
};

export default Tabs;
